import React, { Component } from 'react';
import Webcam from 'react-webcam';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class LoginFace3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errorMessage: '',
      successMessage: '',
      isLoading: false,
      isFaceDetected: false,
    };
    this.webcamRef = React.createRef();
  }

  componentDidMount() {
    console.log('🔹 Starting face detection...');
    this.faceInterval = setInterval(this.detectFace, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.faceInterval);
  }

  detectFace = async () => {
    if (!this.webcamRef.current) return;
    const imageSrc = this.webcamRef.current.getScreenshot();
    if (!imageSrc) return;

    try {
      console.log('📸 Sending image to /validate_face...');
      const res = await axios.post('/validate_face', { image: imageSrc });
      console.log('✅ Response from Flask server:', res.data);

      let detectedEmail = null;

      // --- extract email no matter what the key is ---
      if (res.data.success) {
        if (res.data.email) {
          detectedEmail = res.data.email;
        } else if (res.data.message && res.data.message.includes('@')) {
          const match = res.data.message.match(/[\w\.-]+@[\w\.-]+\.\w+/);
          if (match) detectedEmail = match[0];
        }
      }

      if (detectedEmail) {
        console.log(`🎯 Face recognized as: ${detectedEmail}`);
        this.setState({
          email: detectedEmail,
          successMessage: `Face recognized as ${detectedEmail}`,
          errorMessage: '',
          isFaceDetected: true,
        });
      } else {
        this.setState({
          email: '',
          successMessage: '',
          isFaceDetected: false,
        });
      }
    } catch (err) {
      console.error('❌ Face detection error:', err);
      this.setState({ isFaceDetected: false });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email } = this.state;

    if (!email) {
      this.setState({ errorMessage: 'No face detected. Please try again.' });
      return;
    }

    this.setState({ isLoading: true, errorMessage: '', successMessage: '' });

    try {
      const response = await fetch('/login_face', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.status === 200 && data.success) {
        this.setState({ successMessage: 'Login successful!' });
        this.props.history.push({
          pathname: '/imageconverter',
          state: { email: data.email, balance: data.balance },
        });
      } else {
        this.setState({ errorMessage: data.message || 'Login failed.' });
      }
    } catch (error) {
      console.error('Login error:', error);
      this.setState({ errorMessage: 'Server error during login.' });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const { email, errorMessage, successMessage, isLoading, isFaceDetected } = this.state;

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />
          <div>Face Recognition Login</div>
          <br />

          {/* === Webcam === */}
          <div style={{ marginBottom: '20px' }}>
            <Webcam
              audio={false}
              ref={this.webcamRef}
              screenshotFormat="image/jpeg"
              width={300}
              height={220}
            />
            <p style={{ fontSize: '14px', color: '#666' }}>
              {isFaceDetected ? '✅ Face detected' : '🔍 Waiting for face...'}
            </p>
          </div>

          {/* === Form === */}
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="email">Detected Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={email}
                        readOnly
                        style={{
                          backgroundColor: '#f5f5f5',
                          cursor: 'not-allowed',
                          color: email ? '#000' : '#999',
                        }}
                        placeholder="Face must be recognized to continue"
                      />
                    </div>

                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}

                    <button
                      type="submit"
                      className="btn btn-dark"
                      disabled={isLoading || !isFaceDetected}
                    >
                      {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                  </form>

                  <div className="mt-3">Powered by</div>
                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginFace3);
